import React, { createContext, useContext, useState, useEffect } from "react";
import { code } from "./code";
// 定义上下文类型
interface LanguageContextType {
  selectedLanguage: string;
  setSelectedLanguage: (language: string) => void;
  getCodeSnippet: (page: string, snippetKey: string) => string;
}

// 创建上下文
const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined
);

export const CodeLanguageProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>(() => {
    const savedLanguage = localStorage.getItem("preferredLanguage");
    return savedLanguage || "php";
  });

  const codeSnippets = code;

  const getCodeSnippet = (page: string, snippetKey: string): string => {
    return codeSnippets[page]?.[snippetKey]?.[selectedLanguage] ?? "";
  };

  useEffect(() => {
    localStorage.setItem("preferredLanguage", selectedLanguage);
  }, [selectedLanguage]);

  return (
    <LanguageContext.Provider
      value={{ selectedLanguage, setSelectedLanguage, getCodeSnippet }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

// 使用上下文的 Hook
export const useLanguage = (): LanguageContextType => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
